<template>
  <div class="h-full">
    <Header />
    <div id="teleport-mobile-filters" class="relative z-50"></div>
    <main id="contenuprincipal" role="main">
      <NuxtPage />
    </main>
    <div id="teleport-drawer" class="relative z-50"></div>
    <Footer />
    <!-- <OperationsPrintempsPourLaPlanetePopup /> -->
    <div id="teleport-body-end"></div>
  </div>
</template>

<script>
import Footer from '@/components/layout/Footer.vue'
import Header from '@/components/layout/Header.vue'
import MixinHotjar from '@/mixins/hotjar.client.js'
import MixinPlausible from '@/mixins/plausible.js'
// import { OperationsPrintempsPourLaPlanetePopup } from '#components'

export default {
  components: {
    Header,
    Footer,
  },
  mixins: [MixinPlausible, MixinHotjar],
}
</script>
